import React, { Component } from "react";
import classnames from "classnames";
import {apiUrl} from "../../config/config";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
import $ from "jquery";
import url from "socket.io-client/lib/url";
class SettingsTab extends Component {
  constructor() {
    super();
    this.state = {
      userid: "",
      diary_notes: [],
      data: {},
      errors: {},
      time: "",
      diary_note_id: "",
      note: "",
      action: "",
      duration: "",
      activity: "",
      datasets: [],
      isEditing: false,
      // ECG strip images uploaded from the patient's mobile app
      strips: [],
    };
    this.onChange = this.onChange.bind(this);
    this.onTimeUpdate = this.onTimeUpdate.bind(this);
    this.addDiary = this.addDiary.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ datasets: nextProps.treemenu });
  }
  componentDidMount() {
    //8 10/08/2020

    var self = this;
    let closest = new Date().toISOString();
    $(document).ready(function () {
      $("#mbdTable1").on("", "tr td:nth-child(2)", function () {
        //diary date click functionalaity diabled - 'click'
        var str = $(this)[0].innerText;
        var dt = str.replace(/\//g, "-").split(" ");
        var dt1 = dt[0].split("-");
        var mainDT = dt1[2] + "-" + dt1[0] + "-" + dt1[1] + " " + dt[1];
        var closeFlag = 0;

        var newmainDT = new Date(mainDT);
        console.log("newmainDT", newmainDT);
        newmainDT.setHours(newmainDT.getHours() - 1);

        newmainDT = new Date(newmainDT).toISOString();
        console.log("newmainDT", newmainDT);
        Object.keys(self.state.datasets).map((val, key) => {
          self.state.datasets[val].map((value, key) => {
            const date = new Date(value.date).toISOString();
            if (newmainDT <= date) {
              closest = value.date;
            }
          });
        });
        // console.log('closest',closest);
        if (new Date(closest).toISOString() > new Date(mainDT).toISOString()) {
          Object.keys(self.state.datasets).map((val, key) => {
            self.state.datasets[val].map((value, key) => {
              const date = new Date(value.date).toISOString();
              if (new Date(closest).toISOString() == date && closeFlag == 0) {
                console.log("date1", value.date);
                closeFlag = 1;
              } else if (closeFlag == 1) {
                console.log("date2", value.date);
                closest = value.date;
                closeFlag = 2;
                return;
              }
            });
            if (closeFlag == 2) {
              return;
            }
          });
        }
        console.log("closest", closest);
        //document.getElementById('chart_tab_2').click();
        self.props.onSelectDiary(closest, mainDT);
        //const closest1 = closest.reduce((a, b) => a.Date - newmainDT < b.Date - newmainDT ? a : b);
        //console.log(closest1);
      });
    });
    // var userid = this.props.userid;
    // this.setState({ userid: userid });
    // var getInfo = this.getInfo.bind(this);
    // var deleteDiary = this.deleteDiary.bind(this);
    // var addDiary = this.addDiary.bind(this);
    this.getList();
    this.loadStrips();
  }

  // Strips uploaded via /api/androidapi/uploadEcgStrip — listed under
  // the diary notes so verifiers see patient-captured snapshots in the
  // same place as the activity log.
  loadStrips = () => {
    axios
      .get(apiUrl + "api/patients/ecgStrips?userid=" + this.props.userid)
      .then((res) => {
        this.setState({ strips: (res.data && res.data.strips) || [] });
      })
      .catch(() => {
        this.setState({ strips: [] });
      });
  };

  search(obj, diary_id) {
    var results = [];
    var searchField = "_id";
    var searchVal = diary_id;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i][searchField] == searchVal) {
        results.push(obj[i]);
      }
    }
    return results;
  }
  getList() {
    console.log("here");
    var getInfo = this.getInfo.bind(this);
    var deleteDiary = this.deleteDiary.bind(this);
    var userid = this.props.userid;
    this.setState({ userid: userid });
    setTimeout(() => {
      axios
        .get(apiUrl + "api/patients/getDiaryInfo?userid=" + userid)
        .then((res) => {
        var search = this.search.bind(this);
        this.setState({ diary_notes: res.data });
        //  this.setState({act_duration:res.data});
        //  this.setState({event_activity:res.data});
        //  console.log('diary_notes',this.state.diary_notes);
        const data = {
          columns: [
            {
              label: "SL NO",
              field: "slno",
              sort: "asc",
              width: 30,
            },
            {
              label: "Date",
              field: "datetime",
              sort: "asc",
              width: 100,
            },
            {
              label: "Diary Note",
              field: "diary_note",
              sort: "asc",
              width: 100,
            },
            {
              label: "Duration",
              field: "act_duration",
              sort: "asc",
              width: 100,
            },
            {
              label: "Activity",
              field: "event_activity",
              sort: "asc",
              width: 100,
            },
            {
              label: "Action",
              field: "action",
              sort: "disabled",
              width: 100,
            },
          ],
          rows: [],
        };
        var arrData = [];
        res.data.map(function (patient, i) {
          if (res.data.length != 0) {
            data.rows.push({
              slno: <div style={{ textAlign: "center" }}>{i + 1}</div>,
              datetime: <div style={{ textAlign: "center" }}>{patient.datetime}</div>,
              diary_note: <div style={{ textAlign: "center" }}>{patient.diary_notes}</div>,
              act_duration: <div style={{ textAlign: "center" }}>{patient.act_duration}</div>,
              event_activity: <div style={{ textAlign: "center" }}>{patient.event_activity}</div>,
              action: (
                <div style={{ textAlign: "center" }}>
                  <button
                    type="button"
                    id={patient._id}
                    onClick={getInfo}
                    className="btn btn-warning mr-20"
                    data-toggle="modal"
                    data-target="#addInfoModal"
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    id={patient._id}
                    onClick={deleteDiary}
                    className="btn btn-danger mr-20"
                    style={{ maxWidth: "fit-content" }}
                  >
                    Delete
                  </button>
                </div>
              ),
            });
          }
          // arrData.push({id:patient._id,datetime:patient.datetime,diary_note:patient.diary_notes });
        });
        if (res.data.length == 0) {
          data.rows.push({
            slno: <div style={{ textAlign: "center" }}>-</div>,
            datetime: <div style={{ textAlign: "center" }}>-</div>,
            diary_note: <div style={{ textAlign: "center" }}>No Events Noted</div>,

            action: <div style={{ textAlign: "center" }}></div>,
          });
        }
        this.setState({ data: data });
        console.log("res.data", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    }, 2000);
  }
  getInfo(e) {
    const diary_id = e.currentTarget.id;
    const arr = this.search(this.state.diary_notes, diary_id);
    if (!arr.length) return;

    this.setState({
      diary_note_id: diary_id,
      time: arr[0].datetime,
      note: arr[0].diary_notes,
      duration: arr[0].act_duration,
      activity: arr[0].event_activity,
      action: arr[0].action_data,
      isEditing: true,
    });
  }

  deleteDiary(e) {
    var diary_id = e.currentTarget.id;
    var uid = this.props.userid;
    var did = this.props.databaseid;
    //console.log("diary_id",diary_id);
    const info = {
      diary_id: diary_id,
    };
    axios
      .post(apiUrl + "api/patients/deleteDiary", info)
      .then((res) => {
        console.log(res.data);
        $(".closePopup").click();
        if (url == "/doctor-home") {
          console.log("infourl", url);
          window.location.href = "/doctor-home/" + uid + "/" + did;
        }
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  addDiary() {
    this.setState({
      diary_note_id: "",
      time: "",
      note: "",
      duration: "",
      activity: "",
      action: "",
      isEditing: false,
    });
  }
  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ [e.target.name]: e.target.value });

    console.log(e.target.name);
    console.log(e.target.value);
  };

  onTimeUpdate = (e) => {
    console.log(e);
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ [e.target.name]: e.target.value });
  };
  onSubmitInfo = (e) => {
    e.preventDefault();
    var uid = this.props.userid;
    var did = this.props.databaseid;
    var finTime = this.state.time;

    const info = {
      id: this.state.diary_note_id,
      datetime: finTime,
      diary_notes: this.state.note,
      act_duration: this.state.duration,
      event_activity: this.state.activity,
      action_data: this.state.action,
    };
    console.log("info", info);
    axios
      .post(apiUrl + "api/patients/updateDiary", info)
      .then((res) => {
        console.log("response");
        console.log(res.data);
        $(".closePopup").click();
        if (url == "/doctor-home") {
          console.log("infourl", url);
          window.location.href = "/doctor-home/" + uid + "/" + did;
        }
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onSubmitDiary = (e) => {
    e.preventDefault();
    const uid = this.props.userid;
    const did = this.props.databaseid;

    const info = {
      id: this.state.isEditing ? this.state.diary_note_id : uid,
      datetime: this.state.time,
      diary_notes: this.state.note,
      act_duration: this.state.duration,
      event_activity: this.state.activity,
      action_data: this.state.action,
    };

    const endpoint = this.state.isEditing
      ? apiUrl + "api/patients/updateDiary"
      : apiUrl + "api/patients/addDiary";

    axios
      .post(endpoint, info)
      .then((res) => {
        console.log(res.data);
        $(".closePopup").click();
        if (url == "/doctor-home") {
          console.log("infourl", url);
          window.location.href = "/doctor-home/" + uid + "/" + did;
        }
        this.setState({
          isEditing: false,
          diary_note_id: "",
          time: "",
          note: "",
          duration: "",
          activity: "",
          action: "",
        });
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  render() {
    const { errors } = this.state;
    const fontStack = '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif';
    const accent = "#3F8E48";

    const headerCard = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      padding: "18px 22px",
      borderRadius: "14px",
      background: "linear-gradient(160deg, rgba(30,41,59,0.95) 0%, rgba(15,23,42,0.95) 100%)",
      boxShadow: "0 12px 28px rgba(0,0,0,0.25), 0 0 0 1px rgba(148,163,184,0.18)",
      marginBottom: "16px",
      fontFamily: fontStack,
    };
    const titleStyle = {
      margin: 0,
      fontSize: "18px",
      fontWeight: 700,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      color: "#f8fafc",
    };
    const subtitleStyle = {
      margin: "4px 0 0",
      fontSize: "12px",
      color: "#94a3b8",
    };
    const addBtn = {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 18px",
      background: accent,
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontWeight: 600,
      fontSize: "14px",
      letterSpacing: "0.04em",
      cursor: "pointer",
      boxShadow: `0 6px 18px ${accent}55`,
      transition: "transform 180ms ease, box-shadow 180ms ease",
    };
    const tableWrap = {
      borderRadius: "14px",
      padding: "8px",
      background: "rgba(15,23,42,0.6)",
      boxShadow: "0 0 0 1px rgba(148,163,184,0.12)",
      fontFamily: fontStack,
    };

    const formLabel = {
      display: "block",
      marginBottom: "6px",
      fontSize: "12px",
      fontWeight: 600,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      color: "#94a3b8",
      fontFamily: fontStack,
    };
    const formInput = {
      width: "100%",
      padding: "10px 12px",
      fontSize: "14px",
      borderRadius: "8px",
      border: "1px solid rgba(148,163,184,0.3)",
      background: "rgba(15,23,42,0.6)",
      color: "#f1f5f9",
      outline: "none",
      fontFamily: fontStack,
      resize: "vertical",
    };

    // Real entry count — placeholder rows pushed when there are no
    // diary notes use slno: "-", so they don't count.
    const realRows = (this.state.data && this.state.data.rows) || [];
    const entryCount = realRows.filter(
      (r) =>
        r &&
        r.slno &&
        !(
          r.slno.props &&
          typeof r.slno.props.children === "string" &&
          r.slno.props.children.trim() === "-"
        )
    ).length;

    const countChip = {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "4px 12px",
      borderRadius: "999px",
      background: "rgba(63,142,72,0.18)",
      border: "1px solid rgba(63,142,72,0.45)",
      color: "#bbf7d0",
      fontSize: "12px",
      fontWeight: 600,
      letterSpacing: "0.04em",
      fontFamily: fontStack,
      marginTop: "6px",
    };

    return (
      <React.Fragment>
        <div style={headerCard}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h3 style={titleStyle}>Diary Notes</h3>
            <p style={subtitleStyle}>Patient activity log entries</p>
            <span style={countChip}>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
              {entryCount} {entryCount === 1 ? "entry" : "entries"}
            </span>
          </div>
          <button
            type="button"
            onClick={this.addDiary}
            style={addBtn}
            data-toggle="modal"
            data-target="#addInfoModal"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = `0 12px 26px ${accent}77`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = `0 6px 18px ${accent}55`;
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Add Diary Note
          </button>
        </div>

        <div style={tableWrap}>
          {/*
            Disable MDB's built-in search box, the "Show N entries" dropdown,
            and the "Showing X to Y of Z entries" footer text. Pagination
            stays on so very long lists still chunk into pages, but the
            top/bottom UI noise is gone — entry count is shown as a chip
            in the header instead.
          */}
          <MDBDataTable
            id="mbdTable1"
            data={this.state.data}
            noBottomColumns
            searching={false}
            displayEntries={false}
            info={false}
            entries={10}
            entriesOptions={[10]}
            small
            striped
            hover
          />
        </div>

        {/* ECG strips uploaded from the patient's mobile app */}
        <div style={{ ...tableWrap, marginTop: "16px", padding: "16px" }}>
          <h4
            style={{
              margin: "0 0 4px",
              fontSize: "14px",
              fontWeight: 700,
              letterSpacing: "0.05em",
              textTransform: "uppercase",
              color: "#f8fafc",
              fontFamily: fontStack,
            }}
          >
            ECG strips from mobile ({(this.state.strips || []).length})
          </h4>
          <p style={{ margin: "0 0 12px", fontSize: "12px", color: "#94a3b8", fontFamily: fontStack }}>
            Snapshots uploaded by the patient's phone — click to open full size.
          </p>
          {!(this.state.strips || []).length ? (
            <p style={{ color: "#64748b", fontSize: "13px", fontFamily: fontStack, margin: 0 }}>
              No strips uploaded yet.
            </p>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
              {this.state.strips.map((s) => {
                const src = apiUrl + "api/patients/ecgStrip/" + s._id;
                const when = s.uploaded_at
                  ? new Date(s.uploaded_at).toLocaleString()
                  : "";
                return (
                  <a
                    key={s._id}
                    href={src}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "180px", textDecoration: "none" }}
                  >
                    <img
                      src={src}
                      alt={"ECG strip " + when}
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid rgba(148,163,184,0.3)",
                        background: "#0f172a",
                      }}
                    />
                    <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "4px", fontFamily: fontStack }}>
                      {when}
                    </div>
                  </a>
                );
              })}
            </div>
          )}
        </div>

        <div id="addInfoModal" className="modal fade" role="dialog">
          <div className="modal-dialog" style={{ maxWidth: "560px" }}>
            <div
              className="modal-content"
              style={{
                background: "linear-gradient(160deg, #0f172a 0%, #1e293b 100%)",
                color: "#f1f5f9",
                border: "none",
                borderRadius: "16px",
                boxShadow: "0 25px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(148,163,184,0.18)",
                fontFamily: fontStack,
              }}
            >
              <div
                className="modal-header"
                style={{
                  borderBottom: "1px solid rgba(148,163,184,0.18)",
                  padding: "20px 24px",
                  position: "relative",
                }}
              >
                <h4
                  className="modal-title"
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    color: "#f8fafc",
                    fontFamily: fontStack,
                  }}
                >
                  {this.state.isEditing ? "Edit Diary Note" : "Add Diary Note"}
                </h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: "20px",
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    border: "none",
                    background: "rgba(148,163,184,0.18)",
                    color: "#e2e8f0",
                    fontSize: "14px",
                    opacity: 1,
                    cursor: "pointer",
                  }}
                >
                  &#10006;
                </button>
              </div>

              <form method="post" onSubmit={this.onSubmitDiary}>
                <div className="modal-body" style={{ padding: "24px" }}>
                  <div style={{ marginBottom: "16px" }}>
                    <label style={formLabel}>Time</label>
                    <input
                      type="datetime-local"
                      value={this.state.time}
                      onChange={(e) => this.setState({ time: e.target.value })}
                      name="time"
                      style={formInput}
                      className={classnames({ errors: errors.time })}
                    />
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <label style={formLabel}>Duration</label>
                    <textarea
                      name="duration"
                      onChange={this.onChange}
                      value={this.state.duration}
                      rows={2}
                      style={formInput}
                    />
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <label style={formLabel}>Activity</label>
                    <textarea
                      name="activity"
                      onChange={this.onChange}
                      value={this.state.activity}
                      rows={2}
                      style={formInput}
                    />
                  </div>

                  <div style={{ marginBottom: "8px" }}>
                    <label style={formLabel}>Note</label>
                    <textarea
                      name="note"
                      onChange={this.onChange}
                      value={this.state.note}
                      rows={3}
                      style={formInput}
                    />
                  </div>
                </div>

                <div
                  className="modal-footer"
                  style={{
                    borderTop: "1px solid rgba(148,163,184,0.18)",
                    padding: "16px 24px",
                    display: "flex",
                    gap: "12px",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    type="button"
                    className="closePopup"
                    data-dismiss="modal"
                    style={{
                      padding: "10px 20px",
                      background: "rgba(148,163,184,0.18)",
                      color: "#e2e8f0",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: "14px",
                      letterSpacing: "0.04em",
                      fontFamily: fontStack,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    style={{
                      padding: "10px 20px",
                      background: accent,
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: "14px",
                      letterSpacing: "0.04em",
                      boxShadow: `0 6px 18px ${accent}55`,
                      fontFamily: fontStack,
                    }}
                  >
                    {this.state.isEditing ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SettingsTab;
